/* ImageUploadRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const ImageEditComponent = require("./imageEdit/ImageEditComponent");
const InputFileControl = require("@gluenetworks/steve_ui_core").Control.Action.InputFile;
const _ = require("lodash");

class ImageUploadRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("image-upload-gl");
        this._rootElem.component = this._model;
        this._imageExists = !!this._model._existingImage;

        this._textContent = this._model._description || `Add a photo`;
        this._title = this._model._title || '';
        this._textContentEl = document.createElement("text-content");
        this._textContentEl.innerHTML = `<p>${this._textContent}</p>`;
        this._textContentEl.setAttribute("title", this._title);

        this._previewImageCont = document.createElement("image-preview");
        this._actionContainer = document.createElement("action-container");
        this._actionImg = document.createElement("base-icon-gl");
        this._actionImg.dataset.icon = "application.camera";

        this._buttonsContainer = document.createElement("buttons-list");
        /*
deleteOpts: {
                btnText: "Delete Image",
                veilTitle: "Delete",
                veilMsg: "Are you sure you want to delete the default Dashboard image?"
            },
        */
       this._deleteBtnLabel = _.get(this._model._deleteOpts, 'btnText', "Delete Photo");
       this._deleteVeilTitle = _.get(this._model._deleteOpts, 'veilTitle', "Delete");
       this._deleteVeilMsg = _.get(this._model._deleteOpts, 'veilMsg', "Are you sure you want to delete the photo?");

        this._deleteButton = new ButtonControl({id: "delete", label: this._deleteBtnLabel, disabled: true});
        this._importFromFile = new InputFileControl({
            label: "Update Image",
            acceptFiles: "jpg, jpeg, png, svg",
            darkTheme: true,
            multiple: false
        });

        this._imageEdited = this._imageEdited.bind(this);

        // this._imageEditComponent = ;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _imageEdited(data) {
        this._model.callback(data);
    }
    _onEdit() {
        this._model._muf.displayCustom(
            new ImageEditComponent({
                callback: this._imageEdited,
                existingImage: this._model._existingImage,
                config: this._model._editorConfig,
                opts: this._model._editOpts
            })
        )
        .then(data => {
            this._model.callback(data);
            this._onUpdateImage(data);
        }).catch(err => console.log(err));
    }
    _onDelete() {

        this._model._muf.displayConfirmation(this._deleteVeilMsg, {
            title: this._deleteVeilTitle,
            confirmDetails: {
                text: "Confirm",
                type: "destructive"
            },
            rejectDetails: {
                text: "Cancel",
                type: "text"
            }
        })
        .then(() => {
            if(this._model._defaultImage) {
                return this._onUpdateImage(this._model._defaultImage);
            }
            return this._onUpdateImage("");
        })
        .catch(() => {

        });
    }

    _onImportFromFile(event) {
        event.preventDefault();
        const reader = new FileReader();

        reader.onload = (e) => {
            this._model._existingImage = e.target.result;
            this._importFromFile.setValue("", false);
            this._onEdit.call(this);           
        };

        reader.readAsDataURL(event.target.files[0]);
    }
    _onUpdateImage(data) {
        this._model._existingImage = data;
        this._model.callback(data);
        this._setImagePreview(data);
        if(this._model._defaultImage && this._model._defaultImage === data) {
            this._enableDisableButtons(false);
        } else {
            this._enableDisableButtons(!!data);
        }
    }
    _shutdown(){
        const promArr = Promise.all([
            this._deleteButton.shutdown()
        ]);
        
        return promArr.then(()=>{
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._imageExists = undefined;
            this._previewImageCont = undefined;
            this._buttonsContainer = undefined;
            this._deleteButton = undefined;
            this._importFromFile = undefined;
            this._textContent = undefined;
            this._textContentEl = undefined;
            this._previewImageCont = undefined;
            this._actionContainer = undefined;
            this._actionImg = undefined;
            this._imageEdited = undefined;
            this._deleteBtnLabel = undefined;
            this._deleteVeilTitle = undefined;
            this._deleteVeilMsg = undefined;
            //TODO set all class members to undefined here
            return Promise.resolve();
        });
    }
    _registerListeners(){
        this._deleteButton.on("UserClick", (this._onDelete = this._onDelete.bind(this)));
        this._model.on("UpdateImage", (this._onUpdateImage = this._onUpdateImage.bind(this)));
        this._importFromFile.on("FileHandle", (this._onImportFromFile = this._onImportFromFile.bind(this)));
    }
    _unregisterListeners(){
        this._deleteButton.removeListener("UserClick",this._onDelete);
        this._model.removeListener("UpdateImage", this._onUpdateImage);
        this._importFromFile.removeListener("FileHandle", this._onImportFromFile);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    _setBackgroundColor(el, str) {
        const uCaseStr = str.toUpperCase();
        const firstChar = parseInt(uCaseStr.charCodeAt(0), 10);
        let secondChar = 0;
        if(uCaseStr.length === 2) {
            secondChar = parseInt(uCaseStr.charCodeAt(1), 10);
        }
        const colorNum = (firstChar+secondChar)%14 + 1;
        el.classList.add("bg-color-grp-"+colorNum);
        return el;
    }
    _setImagePreview(imageSrc) {
        this._previewImageCont.innerHTML = "";
        const imgCont = document.createElement("div");
        imgCont.classList.add("image-container");
        this._setBackgroundColor(imgCont, this._model.stringValue);
        if(imageSrc) {
            const img = document.createElement("img");
            img.src = imageSrc;
            imgCont.appendChild(img);
        } else {
            imgCont.appendChild(this._renderString(this._model.stringValue));
        }
        imgCont.appendChild(this._actionContainer);
        this._previewImageCont.appendChild(imgCont);
        if(this._model._defaultImage && this._model._defaultImage === imageSrc) {
            this._renderAction(false);
        } else {
            this._renderAction(!!imageSrc);
        }
        return this._previewImageCont;
    }

    _enableDisableButtons(imageExists = false) {
        if(imageExists) {
            this._deleteButton.setDisabled(false);
            this._deleteButton.show();
            this._importFromFile.setDisabled(false);
            this._importFromFile.hide();
        } else {
            this._deleteButton.setDisabled(true);
            this._deleteButton.hide();
            this._importFromFile.setDisabled(false);
            this._importFromFile.show();
        }
        
    }
    _renderString(str) {
        if(!str) {
            str = "NA";
        }
        const el = document.createElement("p");
        el.innerHTML = str;
        return el;
    }
    _renderButtons() {
        this._buttonsContainer.innerHTML = "";
        this._buttonsContainer.appendChild(this._importFromFile.renderer.rootElement);
        this._buttonsContainer.appendChild(this._deleteButton.renderer.rootElement);
    }

    _renderPreview() {
        this._previewImageCont.innerHTML = "";
        this._setImagePreview(this._model._existingImage);
    }

    _renderAction(hasImage = false) {
        const overlayCont = document.createElement("div");
        overlayCont.classList.add("overlay-container");
        overlayCont.appendChild(this._actionImg);
        overlayCont.appendChild(this._buttonsContainer);
        this._actionContainer.innerHTML = "";
        this._actionContainer.appendChild(overlayCont);
        this._renderActionImg(hasImage);
    }

    _renderActionImg(hasImage) {
        if(hasImage){
            // this._actionImg.src = cameraIcon;
            this._actionImg.dataset.icon = "common.trash_bin";
            this._actionImg.setDarkTheme(true);
        } else {
            this._actionImg.dataset.icon = "application.camera";
        }
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._previewImageCont);
        if(this._imageExists) {
            this._renderPreview();
        }
        this._rootElem.appendChild(this._textContentEl);
        this._renderButtons();
        if(this._model._existingImage === this._model._defaultImage) {
            this._enableDisableButtons(false);
        } else {
            this._enableDisableButtons(this._imageExists);
        }
        return Promise.resolve();
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown(){
        this._shutdown();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports=ImageUploadRenderer;